import { Button, Colors } from "@factorearth/component-library";
import React from "react";
import styles from "./OfflineError.module.scss";

interface OfflineErrorProps {
	cb?: () => void;
	color: Colors;
	errorMessage: string;
}

function OfflineError(props: OfflineErrorProps) {
	const { cb, color, errorMessage } = props;

	return (
		<div style={{ color: color.utils.destructive }} className={styles.errorInfo}>
			{errorMessage}
			<Button
				colorPalette={color}
				onClick={() => {
					cb ? cb() : location.reload();
				}}
				variant="filled">
				Reload
			</Button>
		</div>
	);
}

export default OfflineError;
